import { FormControlLabel, Switch } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";

const ShowHistoricContainer = styled.div`
  display: flex;
  align-self: center;
`;

type Props = {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ShowHistoric = ({ checked, onChange }: Props) => {
  const { t } = useTranslation();
  return (
    <ShowHistoricContainer>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={checked}
            onChange={onChange}
            name="show-historic-switch"
            color="primary"
          />
        }
        label={t("components.depotsStatistic.showHistoricSwitch")}
      />
    </ShowHistoricContainer>
  );
};
